import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Landing.css';

const IconClock = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </svg>
);
const IconInvoice = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><line x1="10" y1="9" x2="8" y2="9"/>
    </svg>
);
const IconProject = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
    </svg>
);
const IconPeople = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
);
const IconId = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="4" width="20" height="16" rx="2"/><circle cx="9" cy="11" r="2.5"/><path d="M5.5 17a3.8 3.8 0 0 1 7 0"/><line x1="15.5" y1="10" x2="19" y2="10"/><line x1="15.5" y1="14" x2="19" y2="14"/>
    </svg>
);
const IconCalendar = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
    </svg>
);
const IconChart = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/>
    </svg>
);
const IconCheck = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12"/>
    </svg>
);
const IconArrow = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
    </svg>
);

const IconDownload = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
    </svg>
);

function ScMockup({ title, children }) {
    return (
        <div className="lp-scr">
            <div className="lp-scr-chrome">
                <div className="lp-scr-chrome-dots">
                    <div className="lp-scr-chrome-dot" style={{ background: '#FF5F57' }} />
                    <div className="lp-scr-chrome-dot" style={{ background: '#FEBC2E' }} />
                    <div className="lp-scr-chrome-dot" style={{ background: '#28C840' }} />
                </div>
                <div className="lp-scr-chrome-title">{title}</div>
                <div style={{ width: 48 }} />
            </div>
            <div className="lp-scr-body">{children}</div>
        </div>
    );
}

/* The mockups show live-looking data, so their dates follow the calendar. A
   hardcoded "Juli 2026" reads as a neglected page the moment August starts. */

/** Today, spelled out German. */
function todayLong() {
    try {
        return new Date().toLocaleDateString('de-DE', {
            weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
        });
    } catch {
        return 'Heute';
    }
}

/** "August" — the running month. */
function monthName(offset = 0) {
    const d = new Date();
    d.setDate(1);
    d.setMonth(d.getMonth() + offset);
    try {
        return d.toLocaleDateString('de-DE', { month: 'long' });
    } catch {
        return 'Monat';
    }
}

/** "August 2026" — the running month with its year. */
function monthLong(offset = 0) {
    const d = new Date();
    d.setDate(1);
    d.setMonth(d.getMonth() + offset);
    try {
        return d.toLocaleDateString('de-DE', { month: 'long', year: 'numeric' });
    } catch {
        return String(d.getFullYear());
    }
}

/** The running ISO week, so the planning mockup does not freeze on one number. */
function isoWeek(d = new Date()) {
    const t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    // Thursday of this week decides the year's week number (ISO 8601).
    t.setUTCDate(t.getUTCDate() + 4 - (t.getUTCDay() || 7));
    const jan1 = new Date(Date.UTC(t.getUTCFullYear(), 0, 1));
    return Math.ceil(((t - jan1) / 86400000 + 1) / 7);
}

const CURRENT_YEAR = new Date().getFullYear();

function ZeitMockup() {
    return (
        <ScMockup title="Zeiterfassung — Anna Schmidt">
            <div className="lp-scr-header">
                <div className="lp-scr-title">{todayLong()}</div>
                <span className="lp-scr-badge lp-scr-badge--green">Läuft</span>
            </div>
            <div className="lp-scr-timer-block">
                <div>
                    <div className="lp-scr-timer-val">03:42:17</div>
                    <div className="lp-scr-timer-meta">Gestartet um 08:15 Uhr</div>
                </div>
                <div className="lp-scr-stop-btn">Stop</div>
            </div>
            <div className="lp-scr-fields-row">
                {[{ label: 'Von', val: '08:15' }, { label: 'Bis', val: '—' }, { label: 'Pause', val: '30 min' }].map(f => (
                    <div key={f.label} className="lp-scr-field">
                        <div className="lp-scr-field-label">{f.label}</div>
                        <div className="lp-scr-field-val">{f.val}</div>
                    </div>
                ))}
            </div>
            <div className="lp-scr-sub-label">Projektbuchungen</div>
            <div className="lp-scr-table-wrap">
                <table className="lp-scr-table">
                    <tbody>
                        {[{ proj: 'Website Relaunch', time: '2:30 h' }, { proj: 'Backend API', time: '1:12 h' }].map(r => (
                            <tr key={r.proj}>
                                <td>{r.proj}</td>
                                <td style={{ textAlign: 'right', color: '#60A5FA', fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>{r.time}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </ScMockup>
    );
}

function RechnungMockup() {
    return (
        <ScMockup title="Rechnungen — Musterfirma GmbH">
            <div className="lp-scr-header">
                <div className="lp-scr-title">Rechnungsübersicht</div>
                <div className="lp-scr-action-btn">+ Neue Rechnung</div>
            </div>
            <div className="lp-scr-filters">
                {['Alle', 'Offen', 'Bezahlt', 'Entwurf'].map((f, i) => (
                    <span key={f} className={`lp-scr-filter${i === 0 ? ' lp-scr-filter--active' : ''}`}>{f}</span>
                ))}
            </div>
            <div className="lp-scr-table-wrap">
                <table className="lp-scr-table">
                    <thead>
                        <tr><th>Nummer</th><th>Kunde</th><th>Betrag</th><th>Status</th></tr>
                    </thead>
                    <tbody>
                        {[
                            { nr: `RE-${CURRENT_YEAR}-047`, kunde: 'TechGmbH Berlin', betrag: '2.400,00 €', badge: 'Gesendet', cls: 'blue' },
                            { nr: `RE-${CURRENT_YEAR}-046`, kunde: 'Muster AG', betrag: '890,00 €', badge: 'Bezahlt', cls: 'green' },
                            { nr: `RE-${CURRENT_YEAR}-045`, kunde: 'StartupX GmbH', betrag: '1.250,00 €', badge: 'Entwurf', cls: 'gray' },
                            { nr: `RE-${CURRENT_YEAR}-044`, kunde: 'Digital Solutions', betrag: '3.600,00 €', badge: 'Bezahlt', cls: 'green' },
                        ].map(r => (
                            <tr key={r.nr}>
                                <td style={{ color: 'rgba(255,255,255,0.45)', fontVariantNumeric: 'tabular-nums' }}>{r.nr}</td>
                                <td>{r.kunde}</td>
                                <td style={{ fontVariantNumeric: 'tabular-nums', fontWeight: 600, color: 'rgba(255,255,255,0.85)' }}>{r.betrag}</td>
                                <td><span className={`lp-scr-badge lp-scr-badge--${r.cls}`}>{r.badge}</span></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </ScMockup>
    );
}

function ProjektMockup() {
    return (
        <ScMockup title="Projektmanagement — Scalewisp">
            <div className="lp-scr-header">
                <div className="lp-scr-title">Aktive Projekte</div>
                <div className="lp-scr-action-btn">+ Neues Projekt</div>
            </div>
            <div className="lp-scr-cards">
                {[
                    { company: 'TechGmbH Berlin', name: 'Website Relaunch', tickets: '8 Tickets', progress: 65, team: '4 Mitarb.' },
                    { company: 'StartupX GmbH', name: 'Backend API v2', tickets: '12 Tickets', progress: 40, team: '3 Mitarb.' },
                    { company: 'Muster AG', name: 'Mobile App MVP', tickets: '5 Tickets', progress: 82, team: '2 Mitarb.' },
                ].map(p => (
                    <div key={p.name} className="lp-scr-card">
                        <div className="lp-scr-card-company">{p.company}</div>
                        <div className="lp-scr-card-name">{p.name}</div>
                        <div className="lp-scr-progress"><div className="lp-scr-progress-bar" style={{ width: `${p.progress}%` }} /></div>
                        <div className="lp-scr-card-meta">
                            <span>{p.tickets}</span><span>{p.progress}%</span><span>{p.team}</span>
                        </div>
                    </div>
                ))}
            </div>
        </ScMockup>
    );
}

function MitarbeiterMockup() {
    return (
        <ScMockup title="Mitarbeiterverwaltung — Übersicht">
            <div className="lp-scr-header">
                <div className="lp-scr-title">Mitarbeiterstunden — {monthLong()}</div>
            </div>
            <div className="lp-scr-table-wrap">
                <table className="lp-scr-table">
                    <thead>
                        <tr><th>Name</th><th>Heute</th><th>Monat</th><th>Überstunden</th><th>Urlaub</th></tr>
                    </thead>
                    <tbody>
                        {[
                            { name: 'Anna Schmidt', heute: '8:30', monat: '92:15', ue: '+4:15', pos: true, urlaub: '3 Tage' },
                            { name: 'Max Müller',   heute: '7:45', monat: '88:00', ue: '-1:00', pos: false, urlaub: '8 Tage' },
                            { name: 'Lisa Wagner',  heute: '8:00', monat: '90:30', ue: '+2:30', pos: true, urlaub: '5 Tage' },
                            { name: 'Tom Fischer',  heute: '0:00', monat: '76:45', ue: '-7:15', pos: false, urlaub: '0 Tage' },
                        ].map(m => (
                            <tr key={m.name}>
                                <td style={{ fontWeight: 600, color: 'rgba(255,255,255,0.85)' }}>{m.name}</td>
                                <td style={{ fontVariantNumeric: 'tabular-nums' }}>{m.heute}</td>
                                <td style={{ fontVariantNumeric: 'tabular-nums' }}>{m.monat}</td>
                                <td style={{ fontVariantNumeric: 'tabular-nums', color: m.pos ? '#4ADE80' : '#F87171', fontWeight: 600 }}>{m.ue}</td>
                                <td style={{ color: 'rgba(255,255,255,0.45)' }}>{m.urlaub}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </ScMockup>
    );
}

// July 2026: July 1 = Wednesday → 2 leading blanks in Mon-first week
const JULY_DAYS = [
    null, null, 1, 2, 3, 4, 5,
    6, 7, 8, 9, 10, 11, 12,
    13, 14, 15, 16, 17, 18, 19,
    20, 21, 22, 23, 24, 25, 26,
    27, 28, 29, 30, 31, null, null,
];

function UrlaubMockup() {
    return (
        <ScMockup title="Urlaub & Abwesenheiten">
            <div className="lp-scr-header">
                <div className="lp-scr-title">Abwesenheitsübersicht</div>
                <div className="lp-scr-action-btn">+ Antrag stellen</div>
            </div>
            <div className="lp-scr-cal">
                <div className="lp-scr-cal-header">
                    <div className="lp-scr-cal-month">{monthLong()}</div>
                    <div className="lp-scr-cal-legend">
                        <span><span className="lp-scr-cal-legend-dot lp-scr-cal-legend-dot--green" />Urlaub</span>
                        <span><span className="lp-scr-cal-legend-dot lp-scr-cal-legend-dot--red" />Krank</span>
                    </div>
                </div>
                <div className="lp-scr-cal-grid">
                    {['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'].map(d => (
                        <div key={d} className="lp-scr-cal-day-name">{d}</div>
                    ))}
                    {JULY_DAYS.map((d, i) => {
                        let cls = 'lp-scr-cal-day';
                        if (d === null) cls += ' lp-scr-cal-day--empty';
                        else if (d === 14) cls += ' lp-scr-cal-day--today';
                        else if (d >= 11 && d <= 13) cls += ' lp-scr-cal-day--holiday';
                        return <div key={i} className={cls}>{d !== null ? d : ''}</div>;
                    })}
                </div>
            </div>
            <div className="lp-scr-table-wrap">
                <table className="lp-scr-table">
                    <thead>
                        <tr><th>Mitarbeiter</th><th>Zeitraum</th><th>Tage</th><th>Status</th></tr>
                    </thead>
                    <tbody>
                        {[
                            { name: 'Anna Schmidt', zeitraum: `11.–13. ${monthName()}`, tage: 3, badge: 'Genehmigt', cls: 'green' },
                            { name: 'Max Müller',   zeitraum: `28. ${monthName()} – 1. ${monthName(1)}`, tage: 5, badge: 'Ausstehend', cls: 'amber' },
                        ].map(r => (
                            <tr key={r.name}>
                                <td style={{ fontWeight: 600, color: 'rgba(255,255,255,0.85)' }}>{r.name}</td>
                                <td>{r.zeitraum}</td>
                                <td>{r.tage}</td>
                                <td><span className={`lp-scr-badge lp-scr-badge--${r.cls}`}>{r.badge}</span></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </ScMockup>
    );
}

function ExportMockup() {
    return (
        <ScMockup title="Auswertungen & Export">
            <div className="lp-scr-header">
                <div className="lp-scr-title">Überstundensaldo — {monthLong()}</div>
            </div>
            <div className="lp-scr-bars-h">
                {[
                    { name: 'Anna Schmidt', val: '+12:30', pct: 78, pos: true },
                    { name: 'Max Müller',   val: '-2:15',  pct: 14, pos: false },
                    { name: 'Lisa Wagner',  val: '+8:00',  pct: 50, pos: true },
                    { name: 'Tom Fischer',  val: '-7:15',  pct: 45, pos: false },
                ].map(r => (
                    <div key={r.name} className="lp-scr-bar-row">
                        <div className="lp-scr-bar-label">{r.name}</div>
                        <div className="lp-scr-bar-track">
                            <div className={`lp-scr-bar-fill${r.pos ? '' : ' lp-scr-bar-fill--red'}`} style={{ width: `${r.pct}%` }} />
                        </div>
                        <div className="lp-scr-bar-val" style={{ color: r.pos ? '#4ADE80' : '#F87171' }}>{r.val}</div>
                    </div>
                ))}
            </div>
            <div className="lp-scr-sub-label" style={{ marginTop: 16 }}>Daten exportieren</div>
            <div className="lp-scr-exports">
                {['Zeitdaten (CSV)', 'Rechnungen (CSV)', 'Urlaubsübersicht (CSV)', 'Alle Daten (ZIP)'].map(label => (
                    <div key={label} className="lp-scr-export-btn"><IconDownload /> {label}</div>
                ))}
            </div>
        </ScMockup>
    );
}

const IconShield = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
);
const IconPhone = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 2 .7 2.9a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.2-1.2a2 2 0 0 1 2.1-.5c.9.3 1.9.6 2.9.7a2 2 0 0 1 1.7 2z"/>
    </svg>
);
const IconScale = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="3" x2="12" y2="21"/><path d="M5 7h14"/><path d="M8 7l-3 6h6L8 7z"/><path d="M16 7l-3 6h6l-3-6z"/>
    </svg>
);
const IconBox = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 16V8l-9-5-9 5v8l9 5 9-5z"/><polyline points="3.3 7.5 12 12.5 20.7 7.5"/><line x1="12" y1="22" x2="12" y2="12.5"/>
    </svg>
);
const IconPlus = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
        <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
    </svg>
);
const IconTimeline = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="3" y1="4" x2="3" y2="20"/><rect x="6" y="5" width="11" height="3.5" rx="1.2"/><rect x="9" y="10.5" width="9" height="3.5" rx="1.2"/><rect x="6" y="16" width="13" height="3.5" rx="1.2"/>
    </svg>
);
const IconDashboard = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7.5" height="9" rx="1.5"/><rect x="13.5" y="3" width="7.5" height="5" rx="1.5"/><rect x="13.5" y="11" width="7.5" height="10" rx="1.5"/><rect x="3" y="15" width="7.5" height="6" rx="1.5"/>
    </svg>
);
const IconBuilding = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="3" width="11" height="18" rx="1.5"/><path d="M15 9h4.5a1.5 1.5 0 0 1 1.5 1.5V21"/><line x1="7.5" y1="7" x2="11.5" y2="7"/><line x1="7.5" y1="11" x2="11.5" y2="11"/><line x1="7.5" y1="15" x2="11.5" y2="15"/>
    </svg>
);
const IconCurrency = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9"/><path d="M15.5 8.5A4 4 0 0 0 9 11.5v1A4 4 0 0 0 15.5 15.5"/><line x1="7.5" y1="11" x2="13" y2="11"/><line x1="7.5" y1="13.5" x2="13" y2="13.5"/>
    </svg>
);
const IconBrand = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9"/><circle cx="8.5" cy="9.5" r="1.3"/><circle cx="15.5" cy="9.5" r="1.3"/><circle cx="9.5" cy="15.5" r="1.3"/><circle cx="15" cy="14.5" r="1.3"/>
    </svg>
);

/** True when the visitor asked the OS for less motion. Guarded for jsdom. */
function usePrefersReducedMotion() {
    const [reduced, setReduced] = useState(false);
    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
        const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        setReduced(mq.matches);
        const onChange = (e) => setReduced(e.matches);
        mq.addEventListener?.('change', onChange);
        return () => mq.removeEventListener?.('change', onChange);
    }, []);
    return reduced;
}

/** Reveal every [data-reveal] element once it scrolls into view. This hook owns `:root.lp-motion`,
 *  which hides them, and sets it only when an observer exists to switch them back on. */
function useRevealOnScroll(deps = []) {
    const canAnimate =
        typeof IntersectionObserver !== 'undefined' &&
        !(typeof window !== 'undefined' &&
          typeof window.matchMedia === 'function' &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    // Layout effect: arming before paint keeps the copy from flashing in and out.
    useLayoutEffect(() => {
        if (!canAnimate) return undefined;
        const root = document.documentElement;
        root.classList.add('lp-motion');
        return () => root.classList.remove('lp-motion');
    }, [canAnimate]);

    useEffect(() => {
        const nodes = Array.from(document.querySelectorAll('[data-reveal]:not(.is-revealed)'));
        if (!nodes.length) return undefined;
        if (typeof IntersectionObserver === 'undefined') {
            nodes.forEach(n => n.classList.add('is-revealed'));
            return undefined;
        }
        const observer = new IntersectionObserver(
            (entries) => entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-revealed');
                    observer.unobserve(entry.target);
                }
            }),
            { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
        );
        nodes.forEach(n => observer.observe(n));
        return () => observer.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

/** Scroll position as a 0–100 progress value plus a "past the fold" flag. */
function useScrollProgress() {
    const [state, setState] = useState({ progress: 0, scrolled: false });
    useEffect(() => {
        const onScroll = () => {
            const doc = document.documentElement;
            const max = (doc.scrollHeight - window.innerHeight) || 1;
            setState({
                progress: Math.min(100, Math.max(0, (window.scrollY / max) * 100)),
                scrolled: window.scrollY > 24,
            });
        };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    return state;
}

/** A running HH:MM:SS so the hero mockup looks like a live screen, not a picture. */
function useLiveTimer(enabled) {
    const [seconds, setSeconds] = useState(3 * 3600 + 42 * 60 + 17);
    useEffect(() => {
        if (!enabled) return undefined;
        const id = setInterval(() => setSeconds(s => s + 1), 1000);
        return () => clearInterval(id);
    }, [enabled]);
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(h)}:${pad(m)}:${pad(s)}`;
}

/** Pointer-follow tilt. Returns handlers and the transform to apply. */
function useTilt(enabled) {
    const [tilt, setTilt] = useState({ x: 0, y: 0 });
    const onMouseMove = (e) => {
        if (!enabled) return;
        const r = e.currentTarget.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width - 0.5;
        const py = (e.clientY - r.top) / r.height - 0.5;
        setTilt({ x: py * -6, y: px * 8 });
    };
    const onMouseLeave = () => setTilt({ x: 0, y: 0 });
    const style = enabled
        ? { transform: `perspective(1400px) rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)` }
        : undefined;
    return { onMouseMove, onMouseLeave, style };
}

/** Moves a CSS spotlight to the cursor. Purely decorative. */
function spotlight(e) {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty('--mx', `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty('--my', `${e.clientY - r.top}px`);
}

function PlanungMockup() {
    /* Reuses the bar-row markup of the Auswertungen screen: the same shape answers "who is
       overbooked" as answers "who has what balance", and the mockups stay one family. */
    return (
        <ScMockup title="Projektplanung — Auslastung">
            <div className="lp-scr-header">
                <div className="lp-scr-title">Kalenderwoche {isoWeek()} — {monthName()}</div>
                <span className="lp-scr-badge lp-scr-badge--amber">1 überbucht</span>
            </div>
            <div className="lp-scr-bars-h">
                {[
                    { name: 'Anna Schmidt', val: '46 / 40 h', pct: 100, over: true },
                    { name: 'Max Müller', val: '32 / 40 h', pct: 80, over: false },
                    { name: 'Lena Bauer', val: '21 / 30 h', pct: 70, over: false },
                    { name: 'Tom Fischer', val: '12 / 40 h', pct: 30, over: false },
                ].map(r => (
                    <div key={r.name} className="lp-scr-bar-row">
                        <div className="lp-scr-bar-label">{r.name}</div>
                        <div className="lp-scr-bar-track">
                            <div
                                className={`lp-scr-bar-fill${r.over ? ' lp-scr-bar-fill--red' : ''}`}
                                style={{ width: `${r.pct}%` }}
                            />
                        </div>
                        <div className="lp-scr-bar-val" style={{ color: r.over ? '#F87171' : '#93C5FD' }}>{r.val}</div>
                    </div>
                ))}
            </div>
            <div className="lp-scr-sub-label" style={{ marginTop: 16 }}>Zeitplan</div>
            <div className="lp-scr-gantt">
                {[
                    { task: 'Konzept MES-Anbindung', offset: 0, span: 34, done: true },
                    { task: 'Schnittstelle SAP', offset: 28, span: 42 },
                    { task: 'Abnahme Werk 2', offset: 66, span: 24, milestone: true },
                ].map(r => (
                    <div key={r.task} className="lp-scr-gantt-row">
                        <div className="lp-scr-gantt-label">{r.task}</div>
                        <div className="lp-scr-gantt-track">
                            <div
                                className={`lp-scr-gantt-bar${r.done ? ' is-done' : ''}${r.milestone ? ' is-milestone' : ''}`}
                                style={{ marginLeft: `${r.offset}%`, width: `${r.span}%` }}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </ScMockup>
    );
}

const SHOWCASE = [
    { key: 'zeit',       title: 'Zeiterfassung',        icon: <IconClock />,    mockup: <ZeitMockup /> },
    { key: 'rechnung',   title: 'Rechnungen',           icon: <IconInvoice />,  mockup: <RechnungMockup /> },
    { key: 'projekt',    title: 'Projekte',             icon: <IconProject />,  mockup: <ProjektMockup /> },
    { key: 'mitarbeiter',title: 'Stundenkonten',        icon: <IconPeople />,   mockup: <MitarbeiterMockup /> },
    { key: 'urlaub',     title: 'Abwesenheiten',        icon: <IconCalendar />, mockup: <UrlaubMockup /> },
    { key: 'planung',    title: 'Planung',              icon: <IconTimeline />, mockup: <PlanungMockup /> },
    { key: 'export',     title: 'Auswertungen',         icon: <IconChart />,    mockup: <ExportMockup /> },
];

/** The daily annoyances this product removes — named plainly, no buzzwords. */
const PAINS = [
    {
        before: 'Stundenzettel per WhatsApp und Zettel',
        after: 'Jede Buchung landet direkt am Projekt — mit Ort, Fahrzeit und Ticket.',
    },
    {
        before: 'Überstunden im Kopf oder in einer Excel-Datei',
        after: 'Soll/Ist je Monat, Mehrarbeit tageweise freigegeben, Saldo jederzeit belegbar.',
    },
    {
        before: 'Rechnungen in Word, PDF per Mail, Rückfragen vom Portal',
        after: 'ZUGFeRD-Rechnung mit eingebettetem XML — maschinenlesbar beim Empfänger.',
    },
    {
        before: 'Angerufen? Wann? Von wem? — im Notizbuch',
        after: 'Wiedervorlage je Deal und Lead, überfällige Anrufe auf einer Tagesliste.',
    },
    {
        before: '„Wer hat nächste Woche Kapazität?" — im Kopf überschlagen',
        after: 'Auslastung je Woche aus Vertragsstunden abzüglich Urlaub, Krankheit und Feiertagen.',
    },
];

const FEATURES = [
    {
        icon: <IconClock />,
        title: 'Zeiterfassung',
        desc: 'Stempeluhr oder Eintrag von Hand: kommen, gehen, Pause, Fahrzeit. Jede Buchung wird auf Projekte und Tickets verteilt — inklusive Arbeitsort für Home-Office-Nachweise. Die gesetzliche Pause zieht das System beim Stoppen selbst ab.',
        chips: ['Stempeluhr', 'Fahrzeit getrennt', 'Home Office / Vor Ort', 'Pause nach ArbZG'],
    },
    {
        icon: <IconScale />,
        title: 'Überstunden & Gleitzeit',
        desc: 'Soll aus dem Arbeitszeitmodell je Wochentag, Ist aus den Buchungen. Mehrarbeit wird pro Tag freigegeben — oder dauerhaft, wenn Sie das für jemanden so festlegen. Gleitzeittage reduzieren den Saldo.',
        chips: ['Freigabe je Tag', '„Dauerhaft OK" je Person', 'Wochenübersicht', 'Monatssaldo'],
    },
    {
        icon: <IconCalendar />,
        title: 'Abwesenheiten',
        desc: 'Urlaub mit Genehmigung und Ablehnungsgrund, Krankmeldungen, Gleittage, Feiertage je Organisation und Urlaubsansprüche inklusive Resttage-Übertrag — alles zusätzlich im Abwesenheitskalender.',
        chips: ['Genehmigungsfluss', 'Abwesenheitskalender', 'Feiertage', 'Resturlaub'],
    },
    {
        icon: <IconBuilding />,
        title: 'Betriebsschließung',
        desc: 'Betriebsferien und Brückentage als Zeitraum hinterlegen: Diese Tage kosten keinen Urlaub und schlagen nicht als Minus im Stundenkonto auf. Wer in der Zeit arbeitet, wird als Ausnahme eingetragen.',
        chips: ['Zeitraum statt Einzeltage', 'Ausnahmen je Person', 'Konflikt-Hinweis'],
    },
    {
        icon: <IconInvoice />,
        title: 'E-Rechnung & Angebote',
        desc: 'Rechnungen, Angebote und Aufträge mit Positionen, Rabatten und Ihrem Logo. Das ZUGFeRD-2.1-XML steckt im PDF — auf Wunsch deutsch oder englisch. Ein angenommenes Angebot wird per Klick zum Auftrag.',
        chips: ['ZUGFeRD 2.1 / Factur-X', 'Deutsch & Englisch', 'Angebot → Auftrag', 'Duplizieren'],
    },
    {
        icon: <IconCurrency />,
        title: 'Fremdwährung & Zahlungseingang',
        desc: 'Rechnungen in anderer Währung mit Kurs oder fest vereinbartem Euro-Betrag. Was die Bank tatsächlich gutgeschrieben hat, wird nachgetragen — die Kursdifferenz rechnet das System aus, statt sie zu schätzen.',
        chips: ['Kurs oder Festbetrag', 'Zahlungseingang', 'Kursdifferenz'],
    },
    {
        icon: <IconPhone />,
        title: 'Vertrieb & Kaltakquise',
        desc: 'Pipeline von „Neu" bis „Gewonnen", Leadliste für Zielfirmen und eine Tagesliste, wer heute anzurufen ist. Jeder Anruf setzt die nächste Wiedervorlage.',
        chips: ['Anrufliste', 'Leadliste', 'Wiedervorlage-Logik'],
    },
    {
        icon: <IconBox />,
        title: 'Produkte & Projekte',
        desc: 'Produktkatalog mit Preisen und Einheiten, Projekte mit Tickets und Stundenbudget. Gebuchte Stunden lassen sich nachträglich auf ein anderes Projekt umbuchen, wenn etwas falsch zugeordnet war.',
        chips: ['Katalog', 'Tickets', 'Stundenbudget', 'Stunden umbuchen'],
    },
    {
        icon: <IconTimeline />,
        tag: 'Neu',
        title: 'Projektplanung & Auslastung',
        desc: 'Dieselben Tickets als Board und als Zeitplan — Balken ziehen verschiebt den Termin. Die Auslastung je Woche kommt aus den Vertragsstunden abzüglich Feiertagen, Krankheit und genehmigtem Urlaub, nicht aus einer getippten Kapazitätszahl.',
        chips: ['Board & Zeitplan', 'Auslastung je Woche', 'Abhängigkeiten', 'Meilensteine'],
    },
    {
        icon: <IconChart />,
        title: 'BWA & Auswertungen',
        desc: 'Monats-BWA mit Umsatz, Kosten und Betriebsergebnis im Verlauf, dazu der kumulierte Umsatz gegen Ihr Jahresziel mit Hochrechnung. Projektberichte können Sie vor dem Versand noch korrigieren.',
        chips: ['Monatsverlauf', 'Umsatzziel je Jahr', 'Projektnachweise', 'CSV-Export'],
    },
    {
        icon: <IconId />,
        title: 'Mitarbeiterprofile & CV',
        desc: 'Profil, Stationen und Projekthistorie einmal pflegen — das CV entsteht daraus als PDF, auf Wunsch mit Foto. Für jede Kundenanfrage eine eigene Variante, und Empfehlungsschreiben oder Zeugnisse hängen Sie je Ausgabe hinten an.',
        chips: ['CV als PDF', 'Varianten je Fokus', 'Anhänge je Ausgabe', 'Foto optional'],
    },
    {
        icon: <IconDashboard />,
        title: 'Dashboard & offene Aufgaben',
        desc: 'Jeder sieht seine Zeiten auf einen Blick. Die Leitung sieht zusätzlich, was auf eine Entscheidung wartet — offene Überstunden, Anträge und fällige Anrufe, direkt von dort aus erledigt.',
        chips: ['Zu genehmigen', 'Fällige Anrufe', 'Badge in der Kopfzeile'],
    },
    {
        icon: <IconBrand />,
        title: 'Ihr Erscheinungsbild',
        desc: 'Logo und Hausfarben einmal hinterlegen — Rechnung, Angebot, Projektbericht und CV tragen sie automatisch. Für dunkle Flächen hinterlegen Sie die helle Fassung Ihres Logos, damit es überall lesbar bleibt.',
        chips: ['Logo & Farben', 'Helle Logo-Fassung', 'Auf jedem Dokument'],
    },
    {
        icon: <IconPeople />,
        title: 'Mehrere Firmen, klare Rollen',
        desc: 'Jede Organisation sieht ausschließlich ihre eigenen Daten. Mitarbeiter, Admin, Super-Admin — jeweils mit eigenen Arbeitszeitmodellen. Die Leitung kann Zeiten eines Mitarbeiters nachtragen; der Eingriff steht im Protokoll.',
        chips: ['Mandantentrennung', '3 Rollen', 'Zeiten nachtragen', 'Protokolliert'],
    },
];

const COMPLIANCE = [
    {
        tag: 'Seit 2025',
        title: 'E-Rechnung im B2B',
        body: 'Unternehmen in Deutschland müssen strukturierte E-Rechnungen empfangen können; die Pflicht zum Versand greift gestaffelt bis 2028. Scalewisp erzeugt ZUGFeRD 2.1 / Factur-X (EN 16931) — das XML liegt im PDF, für Mensch und Maschine.',
    },
    {
        tag: 'BAG 2022',
        title: 'Arbeitszeit muss erfasst werden',
        body: 'Das Bundesarbeitsgericht hat 2022 entschieden, dass Arbeitgeber die Arbeitszeit ihrer Beschäftigten systematisch aufzeichnen müssen. Beginn, Ende und Pausen liegen hier tagesgenau vor — auswertbar und exportierbar.',
    },
];

const SECURITY = [
    { icon: <IconShield />, title: 'Hosting in Deutschland', desc: 'Server und Objektspeicher bei Hetzner, TLS über Let’s Encrypt, Datenbank nicht öffentlich erreichbar.' },
    { icon: <IconPeople />, title: 'Getrennte Mandanten', desc: 'Jede Abfrage ist an die Organisation gebunden. Kein Datenaustausch zwischen Firmen.' },
    { icon: <IconCheck />,  title: 'Nachvollziehbar', desc: 'Ein Aktivitätsprotokoll hält fest, wer wann was geändert hat — von der Freigabe bis zur Rechnung.' },
    { icon: <IconDownload />, title: 'Ihre Daten bleiben Ihre', desc: 'CSV- und PDF-Export für Zeiten, Konten und Belege. Kein Datenexport-Aufpreis.' },
];

const FAQ = [
    {
        q: 'Brauche ich einen Einladungscode?',
        a: 'Ja. Neue Organisationen werden über einen einmaligen Einladungscode angelegt — so bleibt kontrolliert, wer ein Konto eröffnet. Den Code bekommen Sie von uns im Erstgespräch. Wer bereits einen hat, kann sich direkt registrieren.',
    },
    {
        q: 'Wie lange dauert die Einrichtung?',
        a: 'Organisation anlegen, Mitarbeiter einladen, Arbeitszeitmodelle je Wochentag hinterlegen — das ist an einem Vormittag erledigt. Stammdaten wie Kunden und Projekte können Sie danach jederzeit ergänzen.',
    },
    {
        q: 'Wo liegen unsere Daten?',
        a: 'Auf Servern in Deutschland (Hetzner), inklusive der abgelegten PDFs und Logos. Die Verbindung ist durchgehend per TLS verschlüsselt.',
    },
    {
        q: 'Können wir die Daten wieder herausbekommen?',
        a: 'Ja. Zeiten, Stundenkonten und Auswertungen lassen sich als CSV exportieren, Rechnungen und Berichte als PDF. Ein Wechsel bleibt damit möglich.',
    },
    {
        q: 'Passt das auch für mehrere Firmen?',
        a: 'Ja. Die Anwendung ist mandantenfähig: Jede Organisation hat eigene Nutzer, Kunden, Projekte und Belege. Als Super-Admin wechseln Sie zwischen den Firmen, ohne Daten zu vermischen.',
    },
    {
        q: 'Geht das auch vom Handy?',
        // Claimed the way CLAUDE.md records it: the daily screens are built for a phone,
        // the dense admin tables scroll sideways. Overclaiming here costs a demo later.
        a: 'Ja. Zeiterfassung, Urlaubsanträge und die Tickets sind für kleine Bildschirme gebaut — Tabellen werden dort zu Karten, damit nichts abgeschnitten wird. Die dichten Verwaltungstabellen (Finanzen, Auswertungen) lassen sich seitlich scrollen; dafür ist ein größerer Bildschirm angenehmer. Eine App müssen Sie nicht installieren, es läuft im Browser. Helles und dunkles Design folgen der Einstellung Ihres Systems, beides lässt sich auch fest wählen.',
    },
    {
        q: 'Was kostet Scalewisp?',
        a: 'Der Preis richtet sich nach Teamgröße und gewünschten Modulen. Wir stimmen das im Gespräch ab und machen Ihnen ein konkretes Angebot — ohne Einrichtungsgebühr.',
    },
];

const MODULES_TICKER = [
    'Zeiterfassung', 'Stempeluhr', 'Überstundenkonten', 'Gleitzeit', 'Urlaubsanträge',
    'Krankmeldungen', 'Feiertage', 'Betriebsschließung', 'Abwesenheitskalender',
    'Projekte', 'Tickets', 'Projektplanung', 'Zeitplan', 'Auslastung', 'Stunden umbuchen',
    'Aufträge', 'Angebote', 'ZUGFeRD-Rechnungen', 'Fremdwährung', 'Zahlungseingang',
    'Produktkatalog', 'Vertriebspipeline', 'Leadliste', 'Anrufliste',
    'BWA', 'Umsatzziel', 'Projektnachweise', 'CSV-Export',
    'Mitarbeiterprofile', 'CV-Generator', 'CV-Varianten', 'CV-Anhänge',
    'Dashboard', 'Offene Aufgaben', 'Aktivitätsprotokoll',
];

export default function Landing() {
    const [activeTab, setActiveTab] = useState(0);
    const [openFaq, setOpenFaq] = useState(0);
    const [tabsPaused, setTabsPaused] = useState(false);

    const reduceMotion = usePrefersReducedMotion();
    const { progress, scrolled } = useScrollProgress();
    const timer = useLiveTimer(!reduceMotion);
    const tilt = useTilt(!reduceMotion);

    useRevealOnScroll([]);

    // Let the showcase cycle on its own until the visitor takes over.
    useEffect(() => {
        if (reduceMotion || tabsPaused) return undefined;
        const id = setInterval(() => setActiveTab(t => (t + 1) % SHOWCASE.length), 6000);
        return () => clearInterval(id);
    }, [reduceMotion, tabsPaused]);

    const pickTab = (i) => { setActiveTab(i); setTabsPaused(true); };

    const onTabKeyDown = (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        const delta = e.key === 'ArrowRight' ? 1 : -1;
        pickTab((activeTab + delta + SHOWCASE.length) % SHOWCASE.length);
    };

    return (
        <div className="lp">
            <div className="lp-progress" style={{ width: `${progress}%` }} aria-hidden="true" />

            <nav className={`lp-nav${scrolled ? ' lp-nav--solid' : ''}`}>
                <Link to="/" className="lp-nav-logo">
                    <span className="lp-nav-logo-dot" />
                    Scalewisp
                </Link>
                <div className="lp-nav-links">
                    <a href="#funktionen">Funktionen</a>
                    <a href="#einblick">Einblick</a>
                    <a href="#pflichten">Gesetzeslage</a>
                    <a href="#sicherheit">Sicherheit</a>
                    <a href="#faq">FAQ</a>
                </div>
                <div className="lp-nav-actions">
                    <Link to="/login" className="lp-btn lp-btn--ghost">Anmelden</Link>
                    <a href="#kontakt" className="lp-btn lp-btn--primary">Demo vereinbaren</a>
                </div>
            </nav>

            <section className="lp-hero">
                <div className="lp-hero-bg" aria-hidden="true">
                    <span className="lp-aurora lp-aurora--1" />
                    <span className="lp-aurora lp-aurora--2" />
                    <span className="lp-aurora lp-aurora--3" />
                    <span className="lp-hero-grid" />
                </div>

                <div className="lp-hero-inner">
                    <div className="lp-hero-copy">
                        <span className="lp-eyebrow" data-reveal>
                            <span className="lp-eyebrow-dot" />
                            Für Agenturen, Ingenieurbüros und Handwerksbetriebe
                        </span>
                        <h1 className="lp-hero-title" data-reveal>
                            Von der Zeitbuchung<br />
                            bis zur E-Rechnung.
                            <span className="lp-hero-title-accent"> Ein Datenstand.</span>
                        </h1>
                        <p className="lp-hero-sub" data-reveal>
                            Scalewisp erfasst Arbeitszeiten, rechnet Überstunden und Urlaub
                            nachvollziehbar ab und erzeugt ZUGFeRD-Rechnungen, die auch
                            Rechnungsportale annehmen. Kein Export nach Excel, keine
                            Übertragungsfehler, keine zweite Wahrheit.
                        </p>
                        <div className="lp-hero-ctas" data-reveal>
                            <a href="#kontakt" className="lp-btn lp-btn--primary lp-btn--lg">
                                Demo vereinbaren <IconArrow />
                            </a>
                            <Link to="/register" className="lp-btn lp-btn--ghost lp-btn--lg">
                                Einladungscode einlösen
                            </Link>
                        </div>
                        <ul className="lp-hero-trust" data-reveal>
                            <li><span className="lp-hero-trust-icon"><IconCheck /></span> Hosting in Deutschland</li>
                            <li><span className="lp-hero-trust-icon"><IconCheck /></span> DSGVO-konform</li>
                            <li><span className="lp-hero-trust-icon"><IconCheck /></span> ZUGFeRD 2.1</li>
                        </ul>
                    </div>

                    <div
                        className="lp-mockup-wrap"
                        onMouseMove={tilt.onMouseMove}
                        onMouseLeave={tilt.onMouseLeave}
                        data-reveal
                    >
                        <div className="lp-mockup" style={tilt.style}>
                            <div className="lp-mockup-topbar">
                                <div className="lp-mockup-dot" style={{ background: '#FF5F57' }} />
                                <div className="lp-mockup-dot" style={{ background: '#FEBC2E' }} />
                                <div className="lp-mockup-dot" style={{ background: '#28C840' }} />
                                <span className="lp-mockup-url">scalewisp.com/timetracking</span>
                            </div>
                            <div className="lp-mockup-body">
                                <div className="lp-mockup-live">
                                    <div>
                                        <div className="lp-mockup-live-label">
                                            <span className="lp-pulse" /> Läuft — Projekt „MES Rollout"
                                        </div>
                                        <div className="lp-mockup-live-val">{timer}</div>
                                    </div>
                                    <div className="lp-mockup-live-btn">Stop</div>
                                </div>
                                <div className="lp-mockup-kpi-row">
                                    <div className="lp-mockup-kpi">
                                        <div className="lp-mockup-kpi-label">Offene Rechnungen</div>
                                        <div className="lp-mockup-kpi-val lp-mockup-kpi-val--blue">12.400 €</div>
                                    </div>
                                    <div className="lp-mockup-kpi">
                                        <div className="lp-mockup-kpi-label">Stunden ({monthName()})</div>
                                        <div className="lp-mockup-kpi-val">1.248 h</div>
                                    </div>
                                    <div className="lp-mockup-kpi">
                                        <div className="lp-mockup-kpi-label">Saldo Team</div>
                                        <div className="lp-mockup-kpi-val lp-mockup-kpi-val--green">+18:30</div>
                                    </div>
                                </div>
                                <div className="lp-mockup-chart">
                                    <div className="lp-mockup-chart-label">Umsatz — letzte 6 Monate</div>
                                    <div className="lp-mockup-bars">
                                        {[55, 70, 45, 80, 65, 95].map((h, i) => (
                                            <div
                                                key={i}
                                                className={`lp-mockup-bar${i === 5 ? ' lp-mockup-bar--active' : ''}`}
                                                style={{ '--bar-h': `${h}%`, animationDelay: `${i * 90}ms` }}
                                            />
                                        ))}
                                    </div>
                                </div>
                                <div className="lp-mockup-rows">
                                    {[
                                        { name: 'Anna Schmidt', val: '8:30 h', tag: 'Home Office' },
                                        { name: 'Max Müller', val: '7:45 h', tag: 'Vor Ort' },
                                        { name: 'Lena Bauer', val: '6:00 h', tag: 'Büro' },
                                    ].map(r => (
                                        <div key={r.name} className="lp-mockup-row">
                                            <span className="lp-mockup-row-name">{r.name}</span>
                                            <span className="lp-mockup-row-tag">{r.tag}</span>
                                            <span className="lp-mockup-row-val">{r.val}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="lp-mockup-glow" aria-hidden="true" />
                    </div>
                </div>
            </section>

            <div className="lp-ticker" aria-hidden="true">
                <div className={`lp-ticker-track${reduceMotion ? ' is-static' : ''}`}>
                    {[...MODULES_TICKER, ...MODULES_TICKER].map((m, i) => (
                        <span key={`${m}-${i}`} className="lp-ticker-item">{m}</span>
                    ))}
                </div>
            </div>

            <section className="lp-section lp-problem">
                <div className="lp-section-inner">
                    <span className="lp-section-label" data-reveal>Ausgangslage</span>
                    <h2 className="lp-section-title" data-reveal>Das kennen Sie vermutlich</h2>
                    <p className="lp-section-sub" data-reveal>
                        Die Arbeit ist getan — und danach beginnt die zweite Arbeit: übertragen,
                        nachrechnen, nachfragen. Genau diese Strecke fällt weg.
                    </p>
                    <div className="lp-contrast">
                        {PAINS.map((p, i) => (
                            <div className="lp-contrast-row" key={p.before} data-reveal style={{ '--d': `${i * 80}ms` }}>
                                <div className="lp-contrast-before">
                                    <span className="lp-contrast-tag lp-contrast-tag--before">Vorher</span>
                                    <p>{p.before}</p>
                                </div>
                                <span className="lp-contrast-arrow" aria-hidden="true"><IconArrow /></span>
                                <div className="lp-contrast-after">
                                    <span className="lp-contrast-tag lp-contrast-tag--after">Mit Scalewisp</span>
                                    <p>{p.after}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="lp-section lp-features" id="funktionen">
                <div className="lp-section-inner">
                    <span className="lp-section-label" data-reveal>Funktionen</span>
                    <h2 className="lp-section-title" data-reveal>Vierzehn Bereiche, ein System</h2>
                    <p className="lp-section-sub" data-reveal>
                        Alles greift auf dieselben Stammdaten zu. Was einmal erfasst ist, steht
                        überall zur Verfügung — von der Zeitbuchung bis zur Auswertung.
                    </p>
                    <div className="lp-features-grid">
                        {FEATURES.map((f, i) => (
                            <article
                                key={f.title}
                                className="lp-feature-card"
                                onMouseMove={spotlight}
                                data-reveal
                                style={{ '--d': `${(i % 4) * 70}ms` }}
                            >
                                <div className="lp-feature-icon">{f.icon}</div>
                                <h3 className="lp-feature-title">
                                    {f.title}
                                    {f.tag && <span className="lp-feature-tag">{f.tag}</span>}
                                </h3>
                                <p className="lp-feature-desc">{f.desc}</p>
                                <div className="lp-feature-chips">
                                    {f.chips.map(c => <span key={c} className="lp-chip">{c}</span>)}
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            <section className="lp-section lp-showcase" id="einblick">
                <div className="lp-section-inner">
                    <span className="lp-section-label" data-reveal>Einblick</span>
                    <h2 className="lp-section-title" data-reveal>Die echten Oberflächen</h2>
                    <p className="lp-section-sub" data-reveal>
                        Keine Symbolbilder. Das sind die Masken, in denen Ihr Team arbeitet.
                    </p>
                    <div
                        className="lp-showcase-tabs"
                        role="tablist"
                        aria-label="Bereiche"
                        onKeyDown={onTabKeyDown}
                        data-reveal
                    >
                        {SHOWCASE.map((s, i) => (
                            <button
                                key={s.key}
                                role="tab"
                                type="button"
                                aria-selected={activeTab === i}
                                tabIndex={activeTab === i ? 0 : -1}
                                className={`lp-showcase-tab${activeTab === i ? ' lp-showcase-tab--active' : ''}`}
                                onClick={() => pickTab(i)}
                            >
                                {s.icon}
                                <span>{s.title}</span>
                                {activeTab === i && !tabsPaused && !reduceMotion && (
                                    <span className="lp-showcase-tab-progress" aria-hidden="true" />
                                )}
                            </button>
                        ))}
                    </div>
                    {/* Keyed so a tab switch remounts the mockup and replays `lp-scr-in`. No
                        `data-reveal`: the observer runs on mount, so a remount would stay hidden. */}
                    <div className="lp-showcase-panel" key={activeTab}>
                        {SHOWCASE[activeTab].mockup}
                    </div>
                </div>
            </section>

            <section className="lp-section lp-compliance" id="pflichten">
                <div className="lp-section-inner">
                    <span className="lp-section-label" data-reveal>Gesetzeslage</span>
                    <h2 className="lp-section-title" data-reveal>Zwei Pflichten, die niemand aussitzen kann</h2>
                    <p className="lp-section-sub" data-reveal>
                        Beides betrifft fast jeden Betrieb in Deutschland — und beides ist hier
                        eingebaut, nicht angeflanscht.
                    </p>
                    <div className="lp-compliance-grid">
                        {COMPLIANCE.map((c, i) => (
                            <div key={c.title} className="lp-compliance-card" data-reveal style={{ '--d': `${i * 90}ms` }}>
                                <span className="lp-compliance-tag">{c.tag}</span>
                                <h3 className="lp-compliance-title">{c.title}</h3>
                                <p className="lp-compliance-body">{c.body}</p>
                            </div>
                        ))}
                    </div>
                    <p className="lp-footnote" data-reveal>
                        Stand: 2026. Diese Hinweise sind eine Einordnung, keine Rechtsberatung.
                    </p>
                </div>
            </section>

            <section className="lp-section lp-deep">
                <div className="lp-section-inner lp-deep-inner">
                    <div className="lp-deep-copy" data-reveal>
                        <span className="lp-section-label">Im Detail</span>
                        <h2 className="lp-section-title lp-section-title--left">
                            Überstunden, die einer Prüfung standhalten
                        </h2>
                        <p className="lp-deep-lead">
                            Ein Saldo ist nur so gut wie seine Herleitung. Deshalb rechnet
                            Scalewisp jeden Monat aus den Rohdaten neu — statt eine Zahl
                            fortzuschreiben, die niemand mehr nachvollziehen kann.
                        </p>
                        <ul className="lp-deep-list">
                            <li><strong>Soll</strong> kommt aus dem Arbeitszeitmodell je Wochentag — Teilzeit inklusive.</li>
                            <li><strong>Ist</strong> ist die gebuchte Zeit plus Fahrzeit, abzüglich noch nicht freigegebener Mehrarbeit.</li>
                            <li><strong>Abwesenheiten</strong> senken das Soll: Feiertage, Krankheit, genehmigter Urlaub und Betriebsschließungstage.</li>
                            <li><strong>Freigabe</strong> erfolgt tageweise durch die Leitung — mit Grund bei Ablehnung, und auf Wunsch dauerhaft je Person.</li>
                        </ul>
                        <a href="#kontakt" className="lp-btn lp-btn--outline">Im Gespräch ansehen <IconArrow /></a>
                    </div>
                    <div className="lp-deep-visual" data-reveal>
                        <div className="lp-calc">
                            <div className="lp-calc-row">
                                <span>Soll ({monthName()}, 21 Arbeitstage)</span>
                                <strong>168:00</strong>
                            </div>
                            <div className="lp-calc-row">
                                <span>./. Feiertag &amp; Urlaub</span>
                                <strong className="is-muted">−16:00</strong>
                            </div>
                            <div className="lp-calc-row lp-calc-row--sum">
                                <span>Soll bereinigt</span>
                                <strong>152:00</strong>
                            </div>
                            <div className="lp-calc-row">
                                <span>Ist (Buchungen + Fahrzeit)</span>
                                <strong>163:15</strong>
                            </div>
                            <div className="lp-calc-row">
                                <span>./. nicht freigegebene Mehrarbeit</span>
                                <strong className="is-muted">−2:45</strong>
                            </div>
                            <div className="lp-calc-row lp-calc-row--sum">
                                <span>Ist anerkannt</span>
                                <strong>160:30</strong>
                            </div>
                            <div className="lp-calc-total">
                                <span>Saldo {monthName()}</span>
                                <strong>+8:30</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="lp-section lp-steps">
                <div className="lp-section-inner">
                    <span className="lp-section-label" data-reveal>Einstieg</span>
                    <h2 className="lp-section-title" data-reveal>An einem Vormittag startklar</h2>
                    <p className="lp-section-sub" data-reveal>
                        Kein Projektplan, kein Beratertag. Wir richten mit Ihnen ein, was Sie
                        wirklich brauchen.
                    </p>
                    <div className="lp-steps-grid">
                        {[
                            { n: 1, t: 'Erstgespräch', d: 'Wir schauen uns Ihre Abläufe an, zeigen das System an Ihren Beispielen und Sie erhalten den Einladungscode.' },
                            { n: 2, t: 'Einrichten', d: 'Organisation anlegen, Logo und Farben setzen, Mitarbeiter einladen, Arbeitszeitmodelle je Wochentag hinterlegen.' },
                            { n: 3, t: 'Arbeiten', d: 'Zeiten buchen, Anträge genehmigen, Rechnungen stellen. Auswertungen entstehen dabei von selbst.' },
                        ].map((s, i) => (
                            <div key={s.n} className="lp-step" data-reveal style={{ '--d': `${i * 110}ms` }}>
                                <div className="lp-step-num">{s.n}</div>
                                <h3 className="lp-step-title">{s.t}</h3>
                                <p className="lp-step-desc">{s.d}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="lp-section lp-security" id="sicherheit">
                <div className="lp-section-inner">
                    <span className="lp-section-label" data-reveal>Sicherheit &amp; Betrieb</span>
                    <h2 className="lp-section-title" data-reveal>Ihre Daten, nachvollziehbar verwahrt</h2>
                    <div className="lp-security-grid">
                        {SECURITY.map((s, i) => (
                            <div key={s.title} className="lp-security-card" data-reveal style={{ '--d': `${i * 70}ms` }}>
                                <span className="lp-security-icon">{s.icon}</span>
                                <h3>{s.title}</h3>
                                <p>{s.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="lp-section lp-faq" id="faq">
                <div className="lp-section-inner">
                    <span className="lp-section-label" data-reveal>Fragen</span>
                    <h2 className="lp-section-title" data-reveal>Was Interessenten uns zuerst fragen</h2>
                    <div className="lp-faq-list" data-reveal>
                        {FAQ.map((item, i) => (
                            <div key={item.q} className={`lp-faq-item${openFaq === i ? ' is-open' : ''}`}>
                                <button
                                    type="button"
                                    className="lp-faq-q"
                                    aria-expanded={openFaq === i}
                                    onClick={() => setOpenFaq(openFaq === i ? -1 : i)}
                                >
                                    <span>{item.q}</span>
                                    <span className="lp-faq-sign" aria-hidden="true"><IconPlus /></span>
                                </button>
                                <div className="lp-faq-a" role="region">
                                    <p>{item.a}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section id="kontakt" className="lp-section lp-pricing">
                <div className="lp-section-inner">
                    <span className="lp-section-label" data-reveal>Preise</span>
                    <h2 className="lp-section-title" data-reveal>Preis nach Teamgröße und Modulen</h2>
                    <p className="lp-section-sub" data-reveal>
                        Wir nennen Ihnen im Gespräch eine konkrete Zahl — statt einer Tabelle, in
                        der Ihr Fall ohnehin nicht vorkommt.
                    </p>
                    <div className="lp-contact-card" data-reveal>
                        <ul className="lp-contact-points">
                            <li><span className="lp-price-check"><IconCheck /></span> Angebot auf Ihre Teamgröße gerechnet</li>
                            <li><span className="lp-price-check"><IconCheck /></span> Demo an Ihren eigenen Beispielen</li>
                            <li><span className="lp-price-check"><IconCheck /></span> Keine Einrichtungsgebühr, keine versteckten Kosten</li>
                            <li><span className="lp-price-check"><IconCheck /></span> Einladungscode direkt im Gespräch</li>
                        </ul>
                        <div className="lp-contact-actions">
                            <a href="mailto:info@techcrafters.de" className="lp-btn lp-btn--primary lp-btn--lg">
                                E-Mail schreiben
                            </a>
                            <a href="tel:+4974204051093" className="lp-btn lp-btn--outline lp-btn--lg">
                                +49 7420 405 10 93
                            </a>
                        </div>
                        <p className="lp-contact-note">
                            Antwort in der Regel am selben Arbeitstag.
                        </p>
                    </div>
                </div>
            </section>

            <section className="lp-cta">
                <div className="lp-cta-bg" aria-hidden="true" />
                <div className="lp-cta-inner" data-reveal>
                    <h2 className="lp-cta-title">Einmal erfassen. Überall verwendet.</h2>
                    <p className="lp-cta-sub">
                        Zeigen Sie uns Ihren Ablauf — wir zeigen Ihnen, wie er in Scalewisp aussieht.
                    </p>
                    <div className="lp-cta-btns">
                        <a href="mailto:info@techcrafters.de" className="lp-btn lp-btn--primary lp-btn--lg">
                            Demo vereinbaren <IconArrow />
                        </a>
                        <Link to="/login" className="lp-btn lp-btn--ghost lp-btn--lg">
                            Bereits Kunde? Anmelden
                        </Link>
                    </div>
                </div>
            </section>

            <footer className="lp-footer">
                <div className="lp-footer-top">
                    <div className="lp-footer-brand-col">
                        <Link to="/" className="lp-footer-brand">
                            <span className="lp-nav-logo-dot" />
                            Scalewisp
                        </Link>
                        <p className="lp-footer-claim">
                            Zeiterfassung, Abwesenheiten, Vertrieb und Finanzen für kleine und
                            mittlere Betriebe — an einem Ort.
                        </p>
                    </div>
                    <div className="lp-footer-col">
                        <h4>Produkt</h4>
                        <a href="#funktionen">Funktionen</a>
                        <a href="#einblick">Einblick</a>
                        <a href="#pflichten">Gesetzeslage</a>
                        <a href="#sicherheit">Sicherheit</a>
                    </div>
                    <div className="lp-footer-col">
                        <h4>Konto</h4>
                        <Link to="/login">Anmelden</Link>
                        <Link to="/register">Einladungscode einlösen</Link>
                        <a href="#kontakt">Preise</a>
                        <a href="#faq">FAQ</a>
                    </div>
                    <div className="lp-footer-col">
                        <h4>Kontakt</h4>
                        <a href="mailto:info@techcrafters.de">info@techcrafters.de</a>
                        <a href="tel:+4974204051093">+49 7420 405 10 93</a>
                        <Link to="/impressum">Impressum</Link>
                        <Link to="/datenschutz">Datenschutz</Link>
                    </div>
                </div>
                <div className="lp-footer-bottom">
                    {/* Operator per Impressum — the product name is not the legal entity. */}
                    <span className="lp-footer-copy">
                        © {new Date().getFullYear()} Scalewisp — ein Produkt der TechCrafters GmbH
                    </span>
                    <span className="lp-footer-made">Hosting in Deutschland · DSGVO-konform</span>
                </div>
            </footer>
        </div>
    );
}
